module.exports = __webpack_public_path__ + "static/media/faq-gdpr.74b86fba.svg";